import React from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { DefaultFormActions, Form, useEnhancedForm } from '../../apiForm/form';
import { CheckoutFormProps } from '../../apiForm/form/CustomFormProps';
import { TextField } from '../../apiForm/form/input';
import ArrayWrapper from '../../apiForm/wrapper/ArrayWrapper';
import ExpandableFieldset from '../../apiForm/form/ExpandableFieldset';
import CheckboxField from '../../apiForm/form/input/CheckboxField';

export default function ReturnsForm({
  defaultValues = {},
  errors = {},
  onSubmit,
  readonly,
}: CheckoutFormProps<any>) {
  const { t } = useTranslation();
  const { handleSubmit, control, formState, getValues, reset } =
    useEnhancedForm({ defaultValues, errors });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ExpandableFieldset legend={t('form.fieldsets.returnConfiguration')}>
        <CheckboxField
          control={control}
          name="allowReturns"
          disabled={readonly}
          label={`${t('checkoutConfig.label.general.allowReturns')} (${t('checkoutConfig.helperText.general.allowReturns')})`}
        />
        <CheckboxField
          control={control}
          name="enforceSeparateReturns"
          disabled={readonly}
          label={`${t('checkoutConfig.label.general.enforceSeparateReturns')} (${t('checkoutConfig.helperText.general.enforceSeparateReturns')})`}
        />
      </ExpandableFieldset>

      <ExpandableFieldset category="returnReasons">
        <ArrayWrapper
          control={control}
          name="returnReasons"
          defaultValue={{}}
          addLabel={t('checkoutConfig.arrayWrapper.returnReason.add')}
          removeLabel={t('checkoutConfig.arrayWrapper.returnReason.remove')}
          render={(index: number) => (
            <Stack spacing={1}>
              <TextField
                control={control}
                name={`returnReasons[${index}].name`}
                disabled={readonly}
                label={t('checkoutConfig.label.return.reason.name')}
                helperText={t('checkoutConfig.helperText.return.reason.name')}
              />
              <TextField
                control={control}
                name={`returnReasons[${index}].code`}
                disabled={readonly}
                label={t('checkoutConfig.label.return.reason.code')}
                helperText={t('checkoutConfig.helperText.return.reason.code')}
              />
            </Stack>
          )}
        />
      </ExpandableFieldset>

      <DefaultFormActions
        formState={formState}
        cancelNavigationTarget="/"
        noCancelNavigation
        reset={reset}
        getValues={getValues}
      />
    </Form>
  );
}
